import ComingSoonPage from "../../components/ComingSoonPage";
import AppShell from '../../components/AppShell';

export default function VisionGaurd() {
  return (
    <AppShell>
      <div className="lg:col-span-8 space-y-6 text-center">
    <ComingSoonPage
      appName="Vision Gaurd AI"
      teaser="Get real-time alerts and analytics from your CCTV feeds using AI."
      imageSrc="/images/coming-soon/trendpulse.png"
    />
    </div>
    </AppShell>
  );
}

